import { render, staticRenderFns } from "./SamFloatingActions.vue?vue&type=template&id=8b93ab26&scoped=true&"
import script from "./SamFloatingActions.vue?vue&type=script&lang=js&"
export * from "./SamFloatingActions.vue?vue&type=script&lang=js&"
import style0 from "./SamFloatingActions.vue?vue&type=style&index=0&id=8b93ab26&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b93ab26",
  null
  
)

export default component.exports